import { toRaw } from "vue";

const globalStateComputedMixin = {
  computed: {
    cart(){
      return toRaw(this.$store.state.cart);
    },
    mainHref() {
      return this.$store.state.mainHref;
    },
    logoTitle() {
      return this.$store.state.logoTitle;
    },
    logoAlt() {
      return this.$store.state.logoAlt;
    },
    baseAssetsUrl() {
      return this.$store.state.baseAssetsUrl;
    },
    captchaActive() {
      return this.$store.state.captchaActive;
    },
    shopCategoriesTree() {
      return this.$store.state.shopCategoriesTree;
    },
    searchBaseUrl() {
      return this.$store.state.searchBaseUrl;
    },
    baseUrl() {
      return this.$store.state.baseUrl;
    },
    isBurgerMenuOpen() {
      return this.$store.state.isBurgerMenuOpen;
    },
    isOverlayVisible() {
      return this.$store.state.isOverlayVisible;
    },
    customer() {
      return this.$store.state.customer;
    },
    isGuest() {
      return this.$store.state.isGuest;
    },
    loginPageUrl() {
      return this.$store.state.loginPageUrl;
    },
    basketPageUrl() {
      return this.$store.state.basketPageUrl;
    },
    basketCount() {
      return this.$store.state.basketCount;
    },
    serviceUrl() {
      return this.$store.state.service;
    },
    miniFlyout() {
      return this.$store.state.miniFlyout;
    },
    checkoutUrl() {
      return this.$store.state.checkoutUrl;
    },
    csrfToken() {
      return this.$store.state.csrfToken;
    },
    currentModalId() {
      return this.$store.state.currentModalId;
    },
    editedProduct() {
      return this.$store.state.editedProduct;
    },
    pageType() {
      return this.$store.state.pageType;
    }
  }
};

export default globalStateComputedMixin;
